import { render, staticRenderFns } from "./creatDialog.vue?vue&type=template&id=44536612"
import script from "./creatDialog.vue?vue&type=script&lang=js"
export * from "./creatDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports